/**
 * swap a given function 's params
 * @param fn
 */
const swap=fn=>(a,b)=>fn(b,a);
export default swap;


// WEBPACK FOOTER //
// ./src/swap.ts